import {
  Checkmark
} from "./chunk-62PCOUDV.mjs";

// src/dropdown-menu/src/dropdown-option.tsx
import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
import { cx } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
var wrapperClasses = (destructive) => cx(
  "cursor-pointer rounded-sm px-2 py-1 focus:outline-none data-[highlighted]:bg-surface-subtle",
  { "text-state-negative-text": destructive }
);
var Checkbox = ({
  destructive,
  children,
  checked,
  asChild,
  onSelect,
  onCheckedChange
}) => {
  return /* @__PURE__ */ jsx(
    RadixDropdownMenu.CheckboxItem,
    {
      asChild,
      checked,
      className: cx(wrapperClasses(destructive)),
      onCheckedChange,
      onSelect: (e) => {
        onSelect(e);
        e.target.firstElementChild.click();
      },
      children: /* @__PURE__ */ jsxs("div", { className: "flex justify-between gap-4 [&>a]:block [&>a]:w-full", children: [
        children,
        /* @__PURE__ */ jsx(RadixDropdownMenu.ItemIndicator, { children: /* @__PURE__ */ jsx(Checkmark, {}) })
      ] })
    }
  );
};
var Item2 = ({ onSelect, destructive, children, asChild }) => /* @__PURE__ */ jsx(
  RadixDropdownMenu.Item,
  {
    asChild,
    className: cx(wrapperClasses(destructive), {
      "cursor-pointer": Boolean(onSelect)
    }),
    onSelect: (e) => {
      onSelect(e);
    },
    children
  }
);
var Option = ({ checked, children, ...props }) => (
  // if the checked property is defined, we know it's a checkbox
  Boolean(checked !== void 0) ? (
    // eslint-disable-next-line react/jsx-props-no-spreading
    /* @__PURE__ */ jsx(Checkbox, { ...props, checked, children })
  ) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    /* @__PURE__ */ jsx(Item2, { ...props, children })
  )
);

export {
  Option
};
